module.exports = __webpack_public_path__ + "static/sm-bb-logo-6aa2ce5d67df6fa5a956941f9d07461d.jpg";